import { render, staticRenderFns } from "./WaitingVerifikasi.vue?vue&type=template&id=036e5766&scoped=true&"
import script from "./WaitingVerifikasi.vue?vue&type=script&lang=js&"
export * from "./WaitingVerifikasi.vue?vue&type=script&lang=js&"
import style0 from "./WaitingVerifikasi.vue?vue&type=style&index=0&id=036e5766&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036e5766",
  null
  
)

export default component.exports